export default class FlightRequestOffline {
	constructor(pax={}, airport={}, departureDate=null, returnDate=null, departurePeriod=null, returnPeriod=null, flightClass=null) {
		this.pax = pax;
		this.airport = airport;
		this.departureDate = departureDate;
		this.departurePeriod = departurePeriod;
		this.returnDate = returnDate;
		this.returnPeriod = returnPeriod;
		this.flightClass = flightClass;
	}
}



// WEBPACK FOOTER //
// ./src/model/FlightRequestOffline.js